module.exports = __webpack_public_path__ + "static/undraw_online_connection_6778-b8c61fc82c78e253d5045f56d9ed07ea.svg";